t = require('app/scripts/views/internal/teacup-with-helpers')('header_invite')
memberAvatarTemplate = require './member_avatar'

module.exports = t.renderable ({ isInviter, isInternetExplorer, ghost, modelName, memberAdder, avatarUrl, fullName, username, modelType, isLoggedIn, isBoard, signupUrl, isGhostEmailLoggedIn, me, email, isAaMastered }) ->
  t.div '.invited-message', ->
    if isLoggedIn
      if ghost.email
        t.div '.personalized-invite-message', { class: t.classify({ 'logged-in': isLoggedIn }) }, ->
          loginMessage =
            if isBoard
              'youll-need-to-create-an-account-for-trello-with-ghost-email-to-join-this-board'
            else
              'youll-need-to-create-an-account-for-trello-with-ghost-email-to-join-this-team'
          t.format loginMessage, { email: email, 'ghost.email': ghost.email }
        t.a '.quiet.js-signup', { href: signupUrl }, ->
          t.format 'create-an-account'
    else
      t.a '.personalized-invite-trello-logo', { href: '/', target: '_blank', class: t.classify({ 'mod-ie': isInternetExplorer }) }
      if memberAdder
        t.span '.member', ->
          memberAvatarTemplate(memberAdder)
        t.div '.personalized-invite-message', ->
          welcomeMessage =
            if isBoard
              'welcome-to-trello-join-the-modelname-board-to-start-collaborating-with-fullname'
            else
              'welcome-to-trello-join-the-modelname-org-to-start-collaborating-with-fullname'
          t.format welcomeMessage, { fullName: memberAdder.fullName, modelName }
      else
        t.div '.personalized-invite-message', ->
          t.format 'youve-been-invited-to-collaborate-on-modelname', { modelName }

      t.a '.button.primary.personalized-invite-right-button', { href: signupUrl }, ->
        if isBoard
          t.format 'join-board'
        else
          t.format 'join-org'
